<template>
  <el-dialog
    class="manage-data-dialog"
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="visible = false">
    <template slot="title">
      <div class="dialog-header">
        <span class="tips">
          <el-button type="primary" @click="handleResetData">重置数据</el-button>
          <el-tooltip placement="top-start" :open-delay="500">
            <div slot="content" class="reset-tips-text" style="font-size: 14px;line-height:22px">
              <p>1. 第一列为维度，比如地区、平台、月份等，第二列及后面列为具体数字(滚动列表除外)；</p>
              <p>2. 支持批量复制粘贴，如复制excel中数据，批量粘贴；</p>
              <p>3. 双击表头可更改表头字段名称。</p>
            </div>
            <span class="reset-tips-icon"><i class="el-icon-question "></i></span>
          </el-tooltip>
          <span v-if="initDataFlag" class="reset-tips">说明：当前为初始化数据，请重置后添加正确数据</span>
        </span>
        <span class="opti">
          <el-button plain @click="visible=false">取消</el-button>
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </span>
      </div>
    </template>
    <!-- 单数据源 -->
    <div v-if="!isMultipleChartData" class="single-data">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :show-header="true"
        :cell-class-name="getTableCellClass"
        @cell-click="handleCellClick"
        @cell-mouse-enter="handleCellMouseEnter"
        @cell-mouse-leave="handleCellMouseLeave">
        <el-table-column
          v-for="(key,i) in Object.keys(tableHeader)"
          :key="i"
          :prop="key">
          <template slot="header" slot-scope="scope">
            <!-- 表头 -->
            <span @dblclick="handleHeaderDoubleClick(scope.column)">
              <template v-if="editIndex === `-1_${scope.column.property}`">
                <el-input
                  :ref="key"
                  v-model="tableHeader[key]"
                  @paste.native.capture.prevent="handlePaste"
                  @keydown.native="handleKeyDown"
                  @blur="handleBlur" />
              </template>
              <span v-else class="cell-content">{{ tableHeader[key] }}
                <el-select v-if="doubleAxisFlag && key !=='col_0'" v-model="setAxis[key]" class="col-select" placeholder="y轴">
                  <el-option :value="0" label="y1">y1</el-option>
                  <el-option :value="1" label="y2">y2</el-option>
                </el-select>
              </span>
            </span>
          </template>
          <!-- Cell -->
          <template slot-scope="scope">
            <!-- 添加行 -->
            <span :class="hoverRowIndex === scope.row.index? 'is-show':''" class="add-row" @click="handleAddRow(scope.row)">
              <Icon icon="zu34063" />
            </span>
            <!-- 删除行 -->
            <span
              class="delete-row"
              :class="(hoverRowIndex === scope.row.index) && (scope.row.index !== 0 || tableData.length > 1) ? 'is-show':''"
              @click="handleRemoveRow((scope.row.index !== 0 || tableData.length > 1) ? scope.row : '')">
              <Icon icon="zu34064" />
            </span>
            <!-- 编辑 -->
            <template v-if="editIndex === `${scope.row.index}_${scope.column.property}`">
              <el-input
                :ref="key+scope.row.index"
                v-model="scope.row[key]"
                @paste.native.capture.prevent="handlePaste"
                @keydown.native="handleKeyDown" />
            </template>
            <!-- 值 -->
            <span v-else class="cell-content">{{ scope.row[key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 多数据源 -->
    <template v-else>
      <el-tabs v-model="tabActiveName" class="city-tabs" :before-leave="handleTabBeforeLeave" @tab-click="handleTabClick">
        <el-tab-pane v-for="(item,tabIndex) in rawDataClone" :key="tabIndex+'aaa'" :name="item.labelName" :label="item.labelName">
          <el-table
            v-if="tabActiveName === item.labelName"
            ref="table"
            :key="uniqueKey"
            :data="tableData"
            stripe
            border
            :show-header="true"
            :cell-class-name="getTableCellClass"
            @cell-click="handleCellClick"
            @cell-mouse-enter="handleCellMouseEnter"
            @cell-mouse-leave="handleCellMouseLeave">
            <el-table-column
              v-for="(key,idx) in Object.keys(tableHeader)"
              :key="idx"
              :prop="key">
              <template slot="header" slot-scope="scope">
                <!-- 表头 -->
                <span @dblclick="handleHeaderDoubleClick(scope.column)">
                  <template v-if="editIndex === `-1_${scope.column.property}`">
                    <el-input
                      :ref="key"
                      v-model="tableHeader[key]"
                      @paste.native.capture.prevent="handlePaste"
                      @keydown.native="handleKeyDown"
                      @blur="(e) => handleBlur(e,tabIndex)" />
                  </template>
                  <span v-else class="cell-content">{{ tableHeader[key] }}

                    <el-select v-if="doubleAxisFlag && key !=='col_0'" v-model="item.setAxis[key]" class="col-select" placeholder="y轴">
                      <el-option :value="0" label="y1">y1</el-option>
                      <el-option :value="1" label="y2">y2</el-option>
                    </el-select>
                  </span>
                </span>
              </template>
              <!-- Cell -->
              <template slot-scope="scope">
                <!-- 添加行 -->
                <span :class="hoverRowIndex === scope.row.index? 'is-show':''" class="add-row" @click="handleAddRow(scope.row,tabIndex)">
                  <Icon icon="zu34063" />
                </span>
                <!-- 删除行 -->
                <span
                  class="delete-row"
                  :class="(hoverRowIndex === scope.row.index) && (scope.row.index !== 0 || tableData.length > 1) ? 'is-show':''"
                  @click="handleRemoveRow((scope.row.index !== 0 || tableData.length > 1) ? scope.row : '', tabIndex)">
                  <Icon icon="zu34064" />
                </span>
                <!-- 编辑 -->
                <template v-if="editIndex === `${scope.row.index}_${scope.column.property}`">
                  <el-input
                    :ref="key+scope.row.index"
                    v-model="scope.row[key]"
                    @paste.native.capture.prevent="handlePaste"
                    @keydown.native="handleKeyDown"
                    @blur="() => scope.row[key] && (scope.row[key] = scope.row[key].trim())" />
                </template>
                <!-- 值展示 -->
                <span v-else class="cell-content">{{ scope.row[key] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </template>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { TABLE_HEADER, TABLE_ROW } from '@/utils/defaultComponentConfig'
export default {
  name: 'ManageDataDialog',
  components: {

  },
  props: {
    isMultipleChartData: {
      type: Boolean,
    },
    rawData: {
      type: [Array, Object],
    },
    initDataFlag: {
      type: Number,
    },
    // 是否设置双y轴
    doubleAxisFlag: {
      type: Boolean,
    },
    // 双轴模式下列→轴映射（从 chartSet.chartStyle.axisConfig 传入）
    axisConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      rawDataClone: null,
      lastActiveName: '',
      tabActiveName: '',
      hoverRowIndex: undefined,
      visible: true,
      uniqueKey: 'abcde',
      // 选中 Cell 的坐标
      focusIndex: {
        rowIndex: '',
        colIndex: '',
        colName: '',
      },
      // Chrome Opera 的 JavaScript 解析引擎遵循的是新版 ECMA-262 第五版规范。
      // 因此，使用 for-in 语句遍历对象属性时遍历书序并非属性构建顺序。
      // 而 IE6 IE7 IE8 Firefox Safari 的 JavaScript 解析引擎遵循的是较老的 ECMA-262 第三版规范，属性遍历顺序由属性构建的顺序决定。
      // Chrome Opera 中使用 for-in 语句遍历对象属性时会遵循一个规律：
      // 它们会先提取所有 key 的 parseFloat 值为非负整数的属性，然后根据数字顺序对属性排序首先遍历出来，然后按照对象定义的顺序遍历余下的所有属性。
      emptyTableRow: _.cloneDeep(TABLE_ROW),
      // 当折线图设置为双y轴模式时 用于设置列的y轴选项
      setAxis: {},
    }
  },
  computed: {
    editIndex () {
      return `${this.focusIndex.rowIndex}_${this.focusIndex.colName}`
    },

    tableHeader () {
      if (this.isMultipleChartData) {
        return this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData[0]
      } else {
        return this.rawDataClone[0]
      }
    },
    tableData () {
      if (this.isMultipleChartData) {
        return this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData.slice(1)
      } else {
        return this.rawDataClone?.slice(1) ?? []
      }
    },
  },
  watch: {
    visible (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 300)
      }
    },

  },
  created () {
    // rawData 现在永远是纯数组，setAxis 从 axisConfig prop 初始化
    this.rawDataClone = _.cloneDeep(this.rawData)
    this.setAxis = { ...(this.axisConfig || {}) }
    // 多数据源
    if (this.isMultipleChartData) {
      this.lastActiveName = this.tabActiveName = this.rawDataClone[0].labelName
    }
  },
  mounted () {

  },
  methods: {
    handleTabBeforeLeave (activeName, prevActiveName) {
      const cur = this.rawDataClone.find(bar => bar.labelName === prevActiveName)
      cur.realChartData = [this.tableHeader, ...this.tableData]
      this.lastActiveName = activeName
      return true
    },
    // tab click
    handleTabClick (labelName) {
      this.uniqueKey = Math.random()
    },

    // 重置数据
    handleResetData () {
      if (this.isMultipleChartData) {
        this.rawDataClone.forEach(item => {
          item.realChartData = [_.cloneDeep(TABLE_HEADER), _.cloneDeep(TABLE_ROW)]
        })
      } else {
        this.rawDataClone = [_.cloneDeep(TABLE_HEADER), _.cloneDeep(TABLE_ROW)]
        // this.tableHeader = _.cloneDeep(TABLE_HEADER)
        // this.tableData = _.cloneDeep([TABLE_ROW])
      }
    },
    // 添加行
    handleAddRow (row, tabIndex) {
      if (this.isMultipleChartData) {
        this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData.splice(row.index + 2, 0, { ...this.emptyTableRow, index: this.tableData.length })
        this.uniqueKey = Math.random()
      } else {
        this.rawDataClone.splice(row.index + 2, 0, { ...this.emptyTableRow, index: this.tableData.length })
      }
    },
    handleRemoveRow (row, tabIndex) {
      if (tabIndex === undefined) {
        if (row) {
          this.rawDataClone.splice(row.index + 1, 1)
        }
      } else {
        if (row) {
          this.rawDataClone.find((item, i) => i === tabIndex).realChartData.splice(row.index + 1, 1)
        }
      }
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.hoverRowIndex = row.index
    },
    handleCellMouseLeave () {
      this.hoverRowIndex = undefined
    },
    // 确认数据
    handleConfirm () {
      if (this.isMultipleChartData) {
        this.trimStrings(this.rawDataClone)
        // 最后一个激活的tabPane的数据
        const cur = this.rawDataClone.find(bar => bar.labelName === this.lastActiveName)
        cur.realChartData = [this.tableHeader, ...this.tableData]
        this.$emit('confirm', this.rawDataClone)
      } else {
        this.trimStrings(this.tableData)
        this.trimStrings(this.tableHeader)
        if (this.tableData[0].col_0 !== undefined && this.tableData[0].col_0 !== '') {
        // 去除收尾空格
          Object.keys(this.tableHeader).forEach(key => {
            this.tableData.forEach(bar => {
              if (typeof bar[key] === 'string') {
                bar[key] = bar[key].trim()
              }
            })
          })
          this.$emit('confirm', [this.tableHeader, ...this.tableData], this.setAxis)
        } else {
          this.$error('请从第一行第一列开始添加数据')
        }
      }
      this.visible = false
    },
    handleCellClick (row, column, cell, event) {
      this.setFocusIndex(row.index, column.index, column.property)
      this.inputFocus(column, row)
    },
    handleHeaderDoubleClick (column) {
      this.setFocusIndex(-1, column.index, column.property)
      this.inputFocus(column)
    },
    // 选中单元格后，将input focus
    inputFocus (column, row = {}) {
      this.$nextTick(() => {
        if (this.$refs[column.property + ((row.index !== undefined && row.index !== -1) ? row.index : '')]?.length) {
          this.$refs[column.property + ((row.index !== undefined && row.index !== -1) ? row.index : '')][0].focus()
        }
      })
    },
    // 设置当前选择Cell的坐标
    setFocusIndex (row, col, colName) {
      this.focusIndex.rowIndex = row
      this.focusIndex.colIndex = col
      this.focusIndex.colName = colName
    },
    // 设置初始数据的 坐标
    getTableCellClass ({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex
      column.index = columnIndex
    },
    // 粘贴事件
    async handlePaste (e) {
      const clip = e.clipboardData.getData('text/html')
      const template = document.createElement('template')
      template.innerHTML = clip
      const tableEl = template.content.querySelectorAll('table')
      // 粘贴内容为表格
      if (tableEl.length) {
        const clipTableData = []
        for (let i = 0; i < tableEl.length; i++) {
          const res = this.getTableData(tableEl[i])
          clipTableData.push(...res)
        }
        // 填充数据
        let startRow = this.focusIndex.rowIndex

        const changeTable = this.isMultipleChartData
          ? this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData
          : this.rawDataClone
        clipTableData.forEach(bar => {
          // 表头
          if (startRow === -1) {
            let startCol = this.focusIndex.colIndex
            bar.forEach(foo => {
              foo = typeof foo === 'string' ? foo.trim() : foo
              this.$set(changeTable[0], 'col_' + startCol, foo)
              startCol++
            })
          } else {
            // 表格
            if (!changeTable[startRow + 1]) {
              this.$set(changeTable, startRow + 1, { ...this.emptyTableRow, index: startRow })
            }
            let startCol = this.focusIndex.colIndex
            bar.forEach(foo => {
              foo = typeof foo === 'string' ? foo.trim() : foo
              this.$set(changeTable[startRow + 1], 'col_' + startCol, foo)
              startCol++
            })
          }
          startRow++
        })
      } else {
        // 正常的input粘贴行为
        let clipText = e.clipboardData.getData('text')
        await this.$nextTick()
        let refName = ''
        if (this.focusIndex.rowIndex === -1) {
          refName = this.focusIndex.colName
        } else {
          refName = this.focusIndex.colName + this.focusIndex.rowIndex
        }
        const inputEl = this.$refs[refName][0].$el.children[0]
        const selectionStart = inputEl.selectionStart
        const selectionEnd = inputEl.selectionEnd

        const selectStr = inputEl.value.substring(selectionStart, selectionEnd)
        if (selectStr && selectStr.substring(selectStr.length - 1) === ' ') {
          clipText += ' '
        }
        const leftStr = inputEl.value.substring(0, selectionStart)
        const rightStr = inputEl.value.substring(selectionEnd, inputEl.value.length)
        const finalPasteStr = (leftStr + clipText + rightStr + '').trim()
        if (this.focusIndex.rowIndex === -1) {
          if (this.isMultipleChartData) {
            this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData[0][this.focusIndex.colName] = finalPasteStr
          } else {
            this.rawDataClone[0][this.focusIndex.colName] = finalPasteStr
          }
        } else {
          if (this.isMultipleChartData) {
            this.rawDataClone.find(item => item.labelName === this.tabActiveName).realChartData[this.focusIndex.rowIndex + 1][this.focusIndex.colName] = finalPasteStr
          } else {
            this.$set(this.rawDataClone.find((bar, idx) => this.focusIndex.rowIndex + 1 === idx), this.focusIndex.colName, finalPasteStr)
          }
        }
        e.target.value = finalPasteStr
      }
    },
    handleKeyDown (e) {
      switch (true) {
        case e.keyCode === 9: // tab 键事件
          e.preventDefault()
          if (e.shiftKey) { // shift 取反
            this.focusMoveLeft()
          } else {
            this.focusMoveRight()
          }
          break
        case e.keyCode === 38:// up键事件
          e.preventDefault()
          this.focusMoveUp()
          break
        case e.keyCode === 40:// down 键事件
          e.preventDefault()
          this.focusMoveDown()
          break
        case e.keyCode === 37:// left键事件
          e.preventDefault()
          this.focusMoveLeft()
          break
        case e.keyCode === 39:// right 键事件
          e.preventDefault()
          this.focusMoveRight()
          break
        default:
          break
      }
    },
    focusMoveRight () {
      if (this.focusIndex.colIndex + 1 < Object.keys(this.tableHeader).length) {
        this.focusIndex.colIndex++
        this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
        this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
      } else {
        if (this.focusIndex.rowIndex !== this.tableData.length - 1) {
          this.focusIndex.rowIndex++
          this.focusIndex.colIndex = 0
          this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
          this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
        }
      }
    },
    focusMoveLeft () {
      if (this.focusIndex.colIndex > 0) {
        this.focusIndex.colIndex--
        this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
        this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
      } else {
        if (this.focusIndex.rowIndex > 0) {
          this.focusIndex.rowIndex--
          this.focusIndex.colIndex = Object.keys(this.tableHeader).length - 1
          this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
          this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
        }
      }
    },
    focusMoveUp () {
      if (this.focusIndex.rowIndex >= 0) {
        this.focusIndex.rowIndex--
        this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
        this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
      }
    },
    focusMoveDown () {
      if (this.focusIndex.rowIndex < this.tableData.length - 1) {
        this.focusIndex.rowIndex++
        this.focusIndex.colName = 'col_' + this.focusIndex.colIndex
        this.inputFocus({ property: this.focusIndex.colName }, { index: this.focusIndex.rowIndex })
      }
    },
    handleBlur (e, tabIndex) {
      if (e.sourceCapabilities) {
        this.focusIndex.rowIndex = null
      }
      if (this.isMultipleChartData) {
        this.handleMultipleHeaderInputChange(tabIndex)
      }
    },

    // 解析 table 中的数据
    getTableData (table) {
      const arr = []
      for (let i = 0; i < table.rows.length; i++) {
        arr[i] = []
        for (let j = 0; j < table.rows[i].cells.length; j++) {
          arr[i][j] = this.textNodesUnder(table.rows[i].cells[j])
        }
      }
      return arr
    },
    // 获取 Nodes 中的 text
    textNodesUnder (node) {
      var all = []
      for (node = node.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === 3) {
          all.push(node.textContent || '')
        } else {
          all = all.concat(this.textNodesUnder(node))
        }
      }
      return all.join(' ')
    },

    // 多数据源时，表头内容同步
    handleMultipleHeaderInputChange (tabIndex) {
      const curHeaderData = this.rawDataClone[tabIndex].realChartData[0]
      this.rawDataClone.forEach(bar => {
        this.$set(bar.realChartData, 0, _.cloneDeep(curHeaderData))
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

::v-deep.manage-data-dialog{
  .el-dialog{
    margin: 0;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 55vh;
    border-radius: 4px !important;
    display: flex;
    flex-direction: column;
    .dialog-header{
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
    }
    .reset-tips {
      margin-left: 5px;
      // color: #3269ff;
      &-icon{
        margin-left: 10px;
        font-size: 16px;
      }
    }

    .el-dialog__body{
      flex: 1;
      height: 0;
      padding: 0 20px 0 20px !important;
      overflow: scroll;
      .single-data{
        padding-left: 50px;
      }
      .city-tabs{
        height: 100%;
        display: flex;
        flex-direction: column;
        .el-tabs__content{
          flex: 1;
          height: 0;
          overflow: auto;
          .el-tab-pane{
            padding-left: 50px;
            height: 100%;
          }
        }
      }
      .el-table{
        overflow: initial;
        border-left: 1px solid #ebeef5 !important;
        border-top: 1px solid #ebeef5 !important;
      }
      .el-table__header{
        padding: 0 !important;
        .el-table__cell{
          height: inherit;
          &.is-leaf{
            padding: 0;
            .cell{
              padding: 0 !important;
              overflow: initial;
              .cell-content{
                width: 100%;
                min-height: 32px;
                padding: 0 10px;
                font-size: 12px;
                line-height: 32px;
                box-sizing: border-box;
                @include ellipsis(1);
              }
              .el-input{
                font-size: 12px;
                .el-input__inner{
                  padding: 0 10px;
                  background: #fff;
                  border-radius: 0;
                }
              }
            }
          }
        }
      }
      .el-table__body-wrapper{
        overflow: initial;
      }
      .el-table__cell{
        padding: 0;
        &:first-child{
          .cell{
            .add-row{
              opacity: 0;
              position: absolute;
              display: block;
              left: -50px;
              font-size: 20px;
              bottom: 0;
              width: 25px;
              cursor: pointer;
              &.is-show{
                opacity: 1;
              }
            }
            .delete-row{
              opacity: 0;
              position: absolute;
              left: -30px;
              display: block;
              padding-left: 5px;
              font-size: 20px;
              top: 50%;
              transform: translateY(-50%);
              z-index: 10;
              width: 25px;
              cursor: pointer;
              &.is-show{
                opacity: 1;
                color: red;
              }
            }
          }
        }

        .cell{
          min-height: 32px;
          padding: 0;
          position: relative;
          overflow: initial;
          .cell-content{
            padding: 0 10px;
            font-size: 12px;
            line-height: 32px;
            @include ellipsis(1);
            .col-select {
              margin-left: 10px;
              width: 56px;
              .el-input__inner {
                height: 24px;

              }
            }
          }
          .add-row{
            display: none;
          }
          .delete-row{
            display: none;
          }
        }
      }
      .el-input{
        font-size: 12px;
        .el-input__inner{
          padding: 0 10px;
          background: inherit;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
